import {
  DetailsPanelBuildingFragment,
  DetailsPanelFloorFragment,
  useDetailsPanelGetFloorQuery,
  useUpdateFloorMutation,
} from '@/.generated/graphql';
import { gql } from '@apollo/client';
import { datadogRum } from '@datadog/browser-rum';
export type FloorDetails = DetailsPanelFloorFragment & { building: DetailsPanelBuildingFragment };

const buildingFragment = gql`
  fragment DetailsPanelBuilding on Building {
    id
    name
    buildingNumber
    address {
      lines
      country
    }
    site {
      id
      name
    }
  }
`;

const floorFragment = gql`
  fragment DetailsPanelFloor on Floor {
    id: floor_id
    name
    timezone
    area {
      value
      unit
    }
    installation_status
    capacity {
      max
      mid
    }
    last_battery_change_date
    next_battery_change_date
    sensors {
      last_battery_change_date
      next_battery_change_date
      estimated_total_runtime_days
    }
    name
    timezone
    customID
  }
`;

export const GET_FLOOR = gql`
  query DetailsPanelGetFloor($ids: [String!]!) {
    floors(ids: $ids) {
      data {
        building {
          ...DetailsPanelBuilding
        }
        ...DetailsPanelFloor
      }
    }
  }
  ${floorFragment}
  ${buildingFragment}
`;
export const UPDATE_FLOOR = gql`
mutation UpdateFloor($input: UpdateFloorInfoInput!, $building: UpdateBuildingInfoInput!) {
  updateFloorInfo(input: $input) {
    floor {
      ...DetailsPanelFloor
    }
  }
      updateBuildingInfo(input: $building) {
      building {
        ...DetailsPanelBuilding
      }
    }
    ${floorFragment}
  ${buildingFragment}
}
`;

export interface IGetFloorQueryParams {
  spaceId?: string;
}

export const useGetFloorQuery = ({ floorId: spaceId }: { floorId?: string }) => {
  const { data, ...rest } = useDetailsPanelGetFloorQuery({
    // asserted by skip

    variables: { ids: [spaceId!] },
    skip: !spaceId,
    fetchPolicy: 'cache-and-network',
  });
  return {
    data: data?.floors?.data?.[0] ?? null,
    ...rest,
  };
};

export const useSaveFloor = () => {
  return useUpdateFloorMutation({
    onError: (err) => {
      console.error(err.message);
      datadogRum.addError(err, { source: 'space-details-panel' });
    },
    onCompleted: () => {
      datadogRum.addAction('Save', { source: 'space-details-panel' });
    },
    refetchQueries: ['GetFloorDetails', 'useSidebarSiteQuery'],
  });
};
